// src/services/taskApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from '../../store/authSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_URL || 'https://app.krush.in/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('x-auth-token', token);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
if (result.error && result.error.status === 401) {
      api.dispatch(logout());
  }
  return result;
};

export const taskApi = createApi({
  reducerPath: 'taskApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Tasks', 'MyTasks', 'TokenRequests'],
  endpoints: (builder) => ({



    getAssignedTasks: builder.query({
      query: (params) => ({
        url: '/tasks/assigned',
        params,
      }),
      providesTags: ['Tasks'],
    }),

    verifyTask: builder.mutation({
      query: ({ taskId, verificationStatus, verificationNotes }) => ({
        url: `/tasks/${taskId}/verify`,
        method: 'PUT',
        body: { verificationStatus, verificationNotes },
      }),
      invalidatesTags: ['AssignedTasks'],
    }),

    // ============ FIELD EMPLOYEE ============

getMyTasks: builder.query({
  query: (arg) => {
    const status = arg?.status;
    return {
      url: "/tasks/my-tasks", // ✅ confirm your backend route
      params: status ? { status } : undefined,
    };
  },
  providesTags: ["MyTasks"],
}),

// ✅ taskApi.js (REPLACE ONLY THESE MUTATIONS)

respondToTask: builder.mutation({
  query: ({ taskId, accept, rejectionReason }) => ({
    url: `/tasks/${taskId}/respond`,
    method: "PUT", // ✅ FIX: backend is PUT
    body: { accept, rejectionReason },
  }),
  invalidatesTags: ["MyTasks"],
}),

startTask: builder.mutation({
  query: (taskId) => ({
    url: `/tasks/${taskId}/start`,
    method: "PUT", // ✅ FIX: backend is PUT
  }),
  invalidatesTags: ["MyTasks"],
}),

completeTask: builder.mutation({
  query: ({ taskId, fieldNotes, photos, clientSignature }) => ({
    url: `/tasks/${taskId}/complete`,
    method: "PUT", // ✅ FIX: backend is PUT
    body: { fieldNotes, photos, clientSignature },
  }),
  invalidatesTags: ["MyTasks"],
}),


registerDeviceFromTask: builder.mutation({
  query: (payload) => ({
    url: `/devices/register-from-task`,
    method: "POST",
    body: payload,
  }),
  invalidatesTags: ["MyTasks"],
}),
     addTaskPhotos: builder.mutation({
      query: ({ taskId, photos }) => ({
        url: `/tasks/${taskId}/photos`,
        method: 'POST',
        body: { photos },
      }),
      invalidatesTags: ['MyTasks'],
    }),

    // Get assigned tasks (office employee)
    getMyAssignedTasks: builder.query({
      query: ({ status, priority, from, to }) => ({
        url: '/tasks/assigned',
        params: { status, priority, from, to },
      }),
      providesTags: ['AssignedTasks'],
    }),

createTask: builder.mutation({
  query: (taskData) => ({
    url: '/tasks',
    method: 'POST',
    body: taskData,
  }),
  invalidatesTags: ['Tasks', 'AssignedTasks'], // dono tags
}),

    // ============ TOKEN REQUESTS ============
    createTokenRequest: builder.mutation({
      query: (data) => ({
        url: '/token-requests',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['TokenRequests'],
    }),

    getMyTokenRequests: builder.query({
      query: (params) => ({
        url: '/token-requests/my-requests',
        params,
      }),
      providesTags: ['TokenRequests'],
    }),

    getPendingTokenRequests: builder.query({
      query: () => '/token-requests/pending',
      providesTags: ['TokenRequests'],
    }),

    processTokenRequest: builder.mutation({
      query: ({ requestId, ...body }) => ({
        url: `/token-requests/${requestId}/process`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['TokenRequests'],
    }),

    allocateToSubAdmin: builder.mutation({
      query: (data) => ({
        url: '/token-requests/allocate-subadmin',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['TokenRequests'],
    }),

    // ============ GET USERS (for dropdowns) ============
    getFieldEmployees: builder.query({
      query: () => '/users/by-role/field_emp',
    }),

    getManagers: builder.query({
      query: () => '/users/by-role/Manager',
    }),

    getSubAdmins: builder.query({
      query: () => '/users/by-role/sub_admin',
    }),


  }),
});

export const {
  // Office Employee
  useCreateTaskMutation,
  useGetAssignedTasksQuery,
  useVerifyTaskMutation,
  // Field Employee
  useGetMyTasksQuery,
  useRespondToTaskMutation,
  useStartTaskMutation,
  useCompleteTaskMutation,
  useAddTaskPhotosMutation,
  // Token Requests
  useCreateTokenRequestMutation,
  useGetMyTokenRequestsQuery,
  useGetPendingTokenRequestsQuery,
  useProcessTokenRequestMutation,
  useAllocateToSubAdminMutation,
  // Users
  useGetFieldEmployeesQuery,
  useGetManagersQuery,
  useGetSubAdminsQuery,
  useGetMyAssignedTasksQuery,
  useRegisterDeviceFromTaskMutation,

} = taskApi;
